export default __webpack_public_path__ + "static/media/根据地LIVEHOUSE_white.c1ef906e.jpg";